import { Drawer, EmptyState } from '@bb/ui';
import type { AuditEventSummary } from '../../api/client.ts';
import { actorLabel, formatChange, formatTime } from './format.ts';

/** Recent changes of one object: who, when, which fields (secrets and PII arrive already redacted). */
export function HistoryDrawer({ title, events, open, onClose }: { title: string; events: AuditEventSummary[]; open: boolean; onClose: () => void }) {
  return (
    <Drawer open={open} onOpenChange={(next) => !next && onClose()} title={title}>
      {events.length === 0 ? (
        <EmptyState title="No recorded changes yet" />
      ) : (
        <ol className="history">
          {events.map((event) => (
            <li key={event.id}>
              <div>
                <strong>{event.action}</strong> · {actorLabel(event.actor)} · <time dateTime={event.occurredAt}>{formatTime(event.occurredAt)}</time>
              </div>
              {event.summary.length > 0 && (
                <ul>
                  {event.summary.map((change) => (
                    <li key={change.path}>
                      <code>{formatChange(change)}</code>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ol>
      )}
    </Drawer>
  );
}
